<template>
    <ui-field v-bind="this.$props">
        <div class="flex items-center">
            <div class="flex-1 text-sm" :class="field?field:'text-gray-500'" v-text="text" v-if="text"></div>

            <span
                role="checkbox"
                tabindex="0"
                aria-checked="false"
                class="relative inline-block flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full transition-colors focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
                :class="[
                    value ? 'bg-gray-800' : 'bg-gray-200',
                    disabled ? 'cursor-not-allowed' : 'cursor-pointer',
                    text ? 'ml-5': 'ml-0'
                ]"
                @click="disabled ? null : $emit('input', ! value)"
                @keydown.enter="disabled ? null : $emit('input', ! value)"
            >
                <span
                    aria-hidden="true"
                    class="inline-block h-5 w-5 rounded-full bg-white shadow transform transition"
                    :class="(value ? 'translate-x-5' : 'translate-x-0')"
                ></span>
            </span>
        </div>
    </ui-field>
</template>

<script>
export default {
    props: {
        value: Boolean,
        label: String,
        text: String,
        field: String,
        name: String,
        error: String,
        warning: String,
        info: String,
        disabled: Boolean,
    },
}
</script>
